import { CopilotUserResponse } from "@interfaces/copilot.types";

export const getCopilotChatUserId = async (): Promise<string | null> => {
  try {
    
    const response = await fetch(`https://ackodrive.com/p/acko-assist-v2/api/get-or-create-user/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.error(`Failed to get copilot user: ${response.status}`);
      return null;
    }

    const data: CopilotUserResponse = await response.json();

    return data.user.chatUserId;
  } catch (error) {
    console.error("Error fetching copilot chat user ID:", error);
    return null;
  }
};